const ORDER_APPROVED = 'aprobada';
const ORDER_CANCELLED = 'cancelada';
const ORDER_PENDING = 'pendiente';

module.exports = { ORDER_APPROVED, ORDER_CANCELLED, ORDER_PENDING };
